/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_High_FreshInputs */

const en_coach_risk_high_fresh = /** @type {(inputs: Coach_Risk_High_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are rested, but your load has spiked sharply — putting you at elevated injury risk. Scale back intensity or volume this week. Being fresh does not protect against a load spike.`)
};

const de_coach_risk_high_fresh = /** @type {(inputs: Coach_Risk_High_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist erholt, aber die Belastung ist stark angestiegen — Verletzungsrisiko erhöht. Reduzier Intensität oder Umfang diese Woche. Erholung allein schützt nicht vor einem Belastungssprung.`)
};

/**
* | output |
* | --- |
* | "You are rested, but your load has spiked sharply — putting you at elevated injury risk. Scale back intensity or volume this week. Being fresh does not protec..." |
*
* @param {Coach_Risk_High_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_high_fresh = /** @type {((inputs?: Coach_Risk_High_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_High_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_high_fresh(inputs)
	return de_coach_risk_high_fresh(inputs)
});